module.exports = __webpack_public_path__ + "img/gun-turret-base.aebb1aaa.png";